import { __makeTemplateObject } from "tslib";
import { css, jsx } from '@emotion/core';
import { N200, N900 } from '@atlaskit/theme/colors';
var Text = function (_a) {
    var secondary = _a.secondary, children = _a.children, truncate = _a.truncate;
    return (jsx("span", { css: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      display: block;\n      margin: 0;\n      color: ", ";\n\n      ", "\n\n      ", "\n    "], ["\n      display: block;\n      margin: 0;\n      color: ", ";\n\n      ",
            "\n\n      ",
            "\n    "])), N900, truncate &&
            "\n        overflow-x: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      ", secondary &&
            "\n          color: " + N200 + ";\n          font-size: 0.85em;\n      ") }, children));
};
export default Text;
var templateObject_1;
//# sourceMappingURL=Text.js.map